"use strict";

const CustomerTypes = {
  BrandAffiliate: "brandaffiliate",
  Preferred: "preferred",
  PreferredCustomer: "preferred customer",
  Retail: "retail",
  properties: {
    BRAND_AFFILIATE: { stringKey: "DIST", code: 10 },
    RETAIL: { stringKey: "CUST", code: 20 },
    PREFERRED: { stringKey: "preferred", code: 30 },
    PREFERRED_CUSTOMER: { stringKey: "PREF", code: 30 }
  }
};

module.exports = CustomerTypes;
